'use client';

import { Separator, Text } from '@/shared/ui/core';
import { RegistrationCardFooter } from '@/shared/ui/layout/registration-card';
import {
    getSplitWizardStepNumber,
    type SplitWizardState,
} from '@/widgets/registration-wizard/model/split-wizard-state';
import { useSplitWizard } from '@/widgets/registration-wizard/model/split-wizard-context';
import type { ReactNode } from 'react';
import styles from './wizard-footer.module.scss';


type Props = {
    left? : ReactNode;
    right?: ReactNode;
    state : SplitWizardState;
    FooterAccount?: ReactNode;
};


export const WizardFooterSplit = ({ left, right, state, FooterAccount }: Props) => {
    const { stepOrder } = useSplitWizard();

    return (
        <RegistrationCardFooter
            data-template="wizard-footer"
            className={ styles.root }
        >
            <div className={ styles.bottom }>
                <div className={ styles.left }>
                    { left }
                </div>

                <Text
                    as="div"
                    className={ styles.center_content_text }
                >
                    Step { getSplitWizardStepNumber(state.step, stepOrder) + 1 }
                </Text>

                <div className={ styles.bottom_inner }>
                    { FooterAccount }

                    <Separator
                        orientation="vertical"
                        className={ styles.footer_separator }
                    />
                </div>
            </div>

            <div className={ styles.right }>
                { right }
            </div>
        </RegistrationCardFooter>
    );
};
